import React, { useEffect } from "react";
import AgreementsTable from "./views/AgreementsTable";
import AgreementForm from "./forms/AgreementForm";
import {
  agmtAddState,
  agmtEditMainState,
  agmtEditState,
  agmtShowGroupState,
} from "./atoms/atoms";
import { useRecoilState, useRecoilValue } from "recoil";

const Agreements = () => {
  const isAddState = useRecoilValue(agmtAddState);
  const [, setEditMainState] = useRecoilState(agmtEditMainState);
  const [, setAddState] = useRecoilState(agmtAddState);
  const [, setShowGroupView] = useRecoilState(agmtShowGroupState);

  useEffect(() => {
    setAddState(false);
    setShowGroupView(false);
    setEditMainState(false);
  }, []);
  return (
    <div>
      <AgreementsTable />
    </div>
  );
};

export default Agreements;
